import { Box, CircularProgress } from "@mui/material";
//Componente de carga pendiente del mapa.
const GoogleMapFramePending = () => (
  <Box
    sx={{
      height: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      bgcolor: "background.paper",
    }}>
    <CircularProgress />
  </Box>
);

export default GoogleMapFramePending;
